export const businessRole = [
  { value: "BUSINESS_OWNER", label: "Business owner" },
  { value: "EMPLOYEE", label: "Employee" },
  { value: "SOLE_TRADER", label: "Sole trader" },
  { value: "KEY_CONTROLLER", label: "Key controller" }
];
